const devServerControlByUI = JSON.parse(localStorage.getItem('server_Data'));
export default {
  API_BASE_URI: devServerControlByUI?.serverCheckFlag === 'staging' && devServerControlByUI?.serverActivateNumber === '9100000000' ? devServerControlByUI?.serverUrl : process.env.VUE_APP_API_ROOT,
  URI_SUFFIX: {
    sessionCreate: '/v1/session/create',
    customerLogin: '/v2/customer/login',
    customerOtp: '/v2/customer/otp',
    customerLogout: '/v1/customer/logout',
    customerResendOtp: '/v2/customer/resend-otp',
    customerServiceabilityCheck: '/v1/customer/location/serviceability-check',
    customerFaceVerification: '/v1/customer/face-verification',
    customer: '/v1/customer/',
    application: '/v1/application/',
    v2Application: '/v2/application/',
    v3Application: '/v3/application/',
    v4Application: '/v4/application/',
    applicationMarketplace: '/v1/application/marketplace',
    webflow: '/v1/webflow',
    opsTeamMember: '/v1/ops/team-member',
    webflowCustomerDetails: '/v1/webflow/customer-details',
    webflowMembershipDetails: '/v1/webflow/membership-details',
    webflowShortReferral: '/v1/webflow/short-referral',
    v2WebflowShortReferral: '/v2/webflow/short-referral',
    v3WebflowShortReferral: '/v3/webflow/short-referral',
    webflowApproval: '/v1/webflow/approval',
    home: '/v1/home',
    v2Home: '/v2/home',
    applicationState: '/v1/application/state',
    gstin: '/gstin/v1/',
    task: '/v1/task/',
    creditloan: '/v1/creditloan/',
    v2Creditloan: '/v2/creditloan/',
    dualDocument: '/v1/dual-document/',
    dualDocumentDocuments: '/v1/dual-document/documents',
    applicationVernacularDeclaration: '/v1/application/vernacular-declaration',
    applicationVaDetails: '/v1/application/va-details',
    applicationNbfcSignedDocument: '/v1/application/nbfc-singed-document',
    v2Emandate: '/v2/emandate/',
    v5Emandate: '/v5/emandate/',
    v6Emandate: '/v6/emandate/',
    emandateRegister: '/v1/emandate/register/',
    applicationCityAndState: '/v1/application/city-and-state/',
    applicationOwnershipType: '/v1/application/ownership-type',
    applicationBusinessTypeAndCategory: '/v1/application/business-type-and-category',
    applicationAccountType: '/v1/application/account-type',
    applicationStores: '/v1/application/stores',
    signzyDigilockerUrl: '/v1/signzy/digilocker-url',
    signzy: '/v1/signzy/',
    digiLockerSubmitDetails: '/v1/digiLocker/submit-details',
    applicationEducationQualifications: '/v1/application/educational-qualification',
    marketplaceLogoUrl: '/v1/marketplace/logo-url',
    card: '/v1/card',
    perfios: '/v1/perfios/',
    cardSetPin: '/v1/card/set-pin',
    cardLockUnlock: '/v1/card/lock-unlock',
    cardChannelLimit: '/v1/card/channel-limit',
    cardChannelStatus: '/v1/card/channel-status',
    referralStart: '/v1/referral/start',
    customerSupport: '/v1/customer/support/',
    customerTransactionPaymentMethod: '/v1/customer/transaction/payment-method',
    repaymentApplication: '/v1/repayment/application/',
    applicationCreditScore: '/v1/application/credit-score/',
    offers: '/v1/offers',
    scanpay: '/v1/scanpay',
    onboardingMarketplace: '/v1/on-boarding-marketplace',
    supplierTransactionDetails: '/v2/customer/transaction-details/',
    customerBlockedTransactions: '/v1/customer/blocked-transactions/',
    customerPaymentLink: '/v1/customer/payment/link',
    applicationMerchantOnboardingLink: '/v1/application/merchant/onboarding-link',
    v2applicationMerchantOnboardingLink: '/v2/application/merchant/onboarding-link',
    customerPhoneBySession: '/v1/customer/phone-by-session',
    customerReferralLink: '/v1/customer/referral-link',
    creditloanApprovedAmount: '/v1/creditloan/approved-amount/',
    rewards: '/v1/rewards',
    homeFlags: '/v1/home/flags',
    digiLockerKarzaOtp: '/v1/digilocker/karza/otp',
    digiLockerKarzaVerifyOtp: '/v1/digilocker/karza/verify-otp',
    v2digiLockerKarzaVerifyOtp: '/v2/digilocker/karza/verify-otp',
    signdesk: '/v1/emandate/signdesk/request',
    customerBankName: '/v2/customer/banks',
    customerBranchNameIfsc: '/v2/customer/ifsc',
    generateStatement: '/v2/customer/generate-statement',
    initiateTransaction: '/v2/repayment/initiate-transaction',
    otherBanks: '/v1/repayment/other-banks',
    processTransaction: '/v2/repayment/process-transaction',
    initPaytmSubscription: '/v1/emandate/init-paytm-subscription',
    registerPaytmMandate: '/v1/emandate/register-paytm-mandate',
    paymentDetails: '/v1/customer/transaction',
    createConsent: '/v1/onemoney/create-consent',
    gstinVerificationStatus: '/gstin/gstin-verification-status',
    consentStatus: '/v1/consent-status',
    initiateReKyc: '/v1/customer/initiate-rekyc',
    digitap: '/v1/digitap',
    ops: '/v1/ops',
    guarantor: '/v1/guarantor',
    aadhar: '/v1/aadhar',
  },
  getEndpoint(identifier, id = undefined, id2 = undefined) {
    let URI_SUFFIX;
    switch (identifier) {
      case 'sessionCreate':
        URI_SUFFIX = this.URI_SUFFIX.sessionCreate;
        break;
      case 'customerLogin':
        URI_SUFFIX = this.URI_SUFFIX.customerLogin;
        break;
      case 'customerOtp':
        URI_SUFFIX = this.URI_SUFFIX.customerOtp;
        break;
      case 'customerLogout':
        URI_SUFFIX = this.URI_SUFFIX.customerLogout;
        break;
      case 'customerResendOtp':
        URI_SUFFIX = this.URI_SUFFIX.customerResendOtp;
        break;
      case 'customerServiceabilityCheck':
        URI_SUFFIX = this.URI_SUFFIX.customerServiceabilityCheck;
        break;
      case 'customerFaceVerification':
        URI_SUFFIX = this.URI_SUFFIX.customerFaceVerification;
        break;
      case 'customerReferralCode':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/referral-code`;
        break;
      case 'customerNbfcInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/nbfc-info`;
        break;
      case 'customerTransactionDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/transaction-details`;
        break;
      case 'customerLoyaltyPoint':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/loyalty-point`;
        break;
      case 'application':
        URI_SUFFIX = this.URI_SUFFIX.application;
        break;
      case 'applicationState':
        URI_SUFFIX = this.URI_SUFFIX.applicationState;
        break;
      case 'applicationVaDetails':
        URI_SUFFIX = this.URI_SUFFIX.applicationVaDetails;
        break;
      case 'applicationFos':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/fos`;
        break;
      case 'applicationFile':
        URI_SUFFIX = `${this.URI_SUFFIX.application}file/${id}`;
        break;
      case 'applicationTnc':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/tnc`;
        break;
      case 'applicationMarketplaceMemberships':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/marketplace-memberships`;
        break;
      case 'applicationProfile':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/profile`;
        break;
      case 'applicationSelectNbfc':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/select-nbfc`;
        break;
      case 'applicationApprovals':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/approvals`;
        break;
      case 'applicationSummary':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/summary`;
        break;
      case 'applicationSubmit':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/submit`;
        break;
      case 'applicationBusinessOwnershipInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/business-ownership-info`;
        break;
      case 'applicationRegistrationDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/registration-details`;
        break;
      case 'applicationPan':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/pan`;
        break;
      case 'applicationAddressProof':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/address-proof`;
        break;
      case 'v3ApplicationAddressProof':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/address-proof`;
        break;
      case 'applicationAddressProof1':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/address-proof1`;
        break;
      case 'applicationPersonalId':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/personal-id`;
        break;
      case 'v2ApplicationPersonalId':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/personal-id`;
        break;
      case 'v2ApplicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/personal-info`;
        break;
      case 'v3ApplicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/personal-info`;
        break;
      case 'v4ApplicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v4Application}${id}/personal-info`;
        break;
      case 'applicationPersonalInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/personal-info`;
        break;
      case 'applicationQuestionnaire':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/questionnaire`;
        break;
      case 'applicationBusinessInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/business-info`;
        break;
      case 'applicationBusinessInfoV2':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/business-info`;
        break;
      case 'v3ApplicationBusinessInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/business-info`;
        break;
      case 'applicationSkipBusinessRegistrationInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/skip-business-registration-proof`;
        break;
      case 'applicationSkipMarketplaceDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/skip-marketplace-document`;
        break;

      case 'applicationMarketplaceDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/marketplace-document`;
        break;
      case 'applicationMarketplaceAccountLinkingComplete':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/marketplace-linking-complete`;
        break;
      case 'v2ApplicationSubmit':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/submit`;
        break;
      case 'applicationPostApprovalSubmission':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/post-approval-submission`;
        break;
      case 'creditLoanPostApprovalSubmission':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/post-approval-submission`;
        break;
      case 'applicationPersonalKyc':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/personal-kyc`;
        break;
      case 'applicationTransactionDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/transaction-details`;
        break;
      case 'applicationCancelledCheque':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/cancelled-cheque`;
        break;
      case 'applicationBankInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/bank-info`;
        break;
      case 'v2ApplicationBankInfo':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/bank-info`;
        break;
      case 'applicationApplicationDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/application-document`;
        break;
      case 'applicationBusinessRegistrationProof':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/business-registration-proof`;
        break;
      case 'applicationPropertyOwnershipProof':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/property-ownership-proof`;
        break;
      case 'applicationMarketplaceLinkingComplete':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/marketplace-linking-complete`;
        break;
      case 'applicationShopPhotoInside':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/shop-photo-inside`;
        break;
      case 'applicationIdProof':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/id-proof`;
        break;
      case 'applicationSecurityCheque':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/security-cheque`;
        break;
      case 'applicationShopPhotoFront':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/shop-photo-front`;
        break;
      case 'applicationApplicantPhoto':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/applicant-photo`;
        break;
      case 'applicationIsGstVerified':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/is-gst-verified`;
        break;
      case 'applicationCityAndState':
        URI_SUFFIX = `${this.URI_SUFFIX.applicationCityAndState}${id}`;
        break;
      case 'applicationBankDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/bank-details`;
        break;
      case 'applicationContinueAnyway':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/continue-anyway`;
        break;
      case 'applicationComments':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/comments`;
        break;
      case 'applicationCreditScore':
        URI_SUFFIX = `${this.URI_SUFFIX.applicationCreditScore}${id}`;
        break;
      case 'repaymentApplicationPaymentUrl':
        URI_SUFFIX = `${this.URI_SUFFIX.repaymentApplication}${id}/payment-url`;
        break;
      case 'applicationMarketplace':
        URI_SUFFIX = this.URI_SUFFIX.applicationMarketplace;
        break;
      case 'applicationVernacularDeclaration':
        URI_SUFFIX = this.URI_SUFFIX.applicationVernacularDeclaration;
        break;
      case 'applicationNbfcSignedDocument':
        URI_SUFFIX = this.URI_SUFFIX.applicationNbfcSignedDocument;
        break;
      case 'applicationOwnershipType':
        URI_SUFFIX = this.URI_SUFFIX.applicationOwnershipType;
        break;
      case 'applicationEducationQualifications':
        URI_SUFFIX = this.URI_SUFFIX.applicationEducationQualifications;
        break;
      case 'applicationBusinessTypeAndCategory':
        URI_SUFFIX = this.URI_SUFFIX.applicationBusinessTypeAndCategory;
        break;
      case 'applicationAccountType':
        URI_SUFFIX = this.URI_SUFFIX.applicationAccountType;
        break;
      case 'applicationStores':
        URI_SUFFIX = this.URI_SUFFIX.applicationStores;
        break;
      case 'creditTerms':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/credit-terms`;
        break;
      case 'applicationVernacularDeclarationById':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/vernacular-declaration`;
        break;
      case 'applicationDocumentUploadComplete':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/document-upload-complete`;
        break;
      case 'applicationNachTemplate':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Emandate}${id}/nach-template/`;
        break;
      case 'applicationNachMandate':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Emandate}${id}/nach-mandate/`;
        break;
      case 'applicationTncDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Application}${id}/tnc-document`;
        break;
      case 'applicationBankStatement':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/bank-statement`;
        break;
      case 'applicationGst':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/gst`;
        break;
      case 'applicationDualName':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/dual-name`;
        break;
      case 'applicationDualDob':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/dual-dob`;
        break;
      case 'applicationResolveComment':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/resolve-comment`;
        break;
      case 'v5Emandate':
          URI_SUFFIX = `${this.URI_SUFFIX.v5Emandate}${id}/banks/`;
          break;
      case 'emandateRegister':
        URI_SUFFIX = `${this.URI_SUFFIX.emandateRegister}${id}`;
        break;
      case 'webflow':
        URI_SUFFIX = this.URI_SUFFIX.webflow;
        break;
      case 'opsTeamMember':
        URI_SUFFIX = this.URI_SUFFIX.opsTeamMember;
        break;
      case 'webflowCustomerDetails':
        URI_SUFFIX = this.URI_SUFFIX.webflowCustomerDetails;
        break;
      case 'webflowMembershipDetails':
        URI_SUFFIX = this.URI_SUFFIX.webflowMembershipDetails;
        break;
      case 'webflowShortReferral':
        URI_SUFFIX = this.URI_SUFFIX.webflowShortReferral;
        break;
      case 'v2WebflowShortReferral':
        URI_SUFFIX = this.URI_SUFFIX.v2WebflowShortReferral;
        break;
      case 'v3WebflowShortReferral':
        URI_SUFFIX = this.URI_SUFFIX.v3WebflowShortReferral;
        break;
      case 'webflowApproval':
        URI_SUFFIX = this.URI_SUFFIX.webflowApproval;
        break;
      case 'home':
        URI_SUFFIX = this.URI_SUFFIX.home;
        break;
      case 'supplier':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Home}/on-boarding-marketplace`;
        break;
      case 'supplierTransaction':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}transaction-supplier/${id}`;
        break;
      case 'PaymentAmountPayable':
        URI_SUFFIX = this.URI_SUFFIX.paymentDetails;
        break;
      case 'multiInvoicePayment':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}multi-invoice-transaction`;
        break;
      case 'processPayment':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}process-payment`;
        break;
      case 'verifyPaymentOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}verify-payment-otp`;
        break;
      case 'resendPaymentOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}resend-payment-otp`;
        break;
      case 'rePaymentDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.paymentDetails}/${id}`;
        break;
      case 'v3ApplicationMarketplaceDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v3Application}${id}/marketplace-document`;
        break;
      case 'v2applicationMerchantOnboardingLink':
        URI_SUFFIX = this.URI_SUFFIX.v2applicationMerchantOnboardingLink;
        break;
      case 'validateVpa':
        URI_SUFFIX = `${this.URI_SUFFIX.scanpay}/validate-vpa`;
        break;
      case 'eligibilityCheck':
        URI_SUFFIX = `${this.URI_SUFFIX.scanpay}/eligibility-check`;
        break;
      case 'mpinVerify':
        URI_SUFFIX = `${this.URI_SUFFIX.scanpay}/mpin-verify`;
        break;
      case 'signzyDigilockerUrl':
        URI_SUFFIX = this.URI_SUFFIX.signzyDigilockerUrl;
        break;
      case 'signzyDigilockerStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.signzy}${id}/digilocker-status`;
        break;
      case 'signzyVideoVerification':
        URI_SUFFIX = `${this.URI_SUFFIX.signzy}${id}/video-verification`;
        break;
      case 'digiLockerSubmitDetails':
        URI_SUFFIX = this.URI_SUFFIX.digiLockerSubmitDetails;
        break;
      case 'marketplaceLogoUrl':
        URI_SUFFIX = this.URI_SUFFIX.marketplaceLogoUrl;
        break;
      case 'gstinLogin':
        URI_SUFFIX = `${this.URI_SUFFIX.gstin}${id}/login`;
        break;
      case 'gstinConsent':
        URI_SUFFIX = `${this.URI_SUFFIX.gstin}${id}/consent`;
        break;
      case 'gstinOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.gstin}${id}/otp`;
        break;
      case 'task':
        URI_SUFFIX = `${this.URI_SUFFIX.task}${id}`;
        break;
      case 'creditloanLoanDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/loan-document`;
        break;
      case 'v2CreditloanLoanDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.v2Creditloan}${id}/loan-document`;
        break;
      case 'creditloanAmountChange':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/amount-change`;
        break;
      case 'dualDocumentDocuments':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocumentDocuments}`;
        break;
      case 'card':
        URI_SUFFIX = `${this.URI_SUFFIX.card}`;
        break;
      case 'cardSetPin':
        URI_SUFFIX = `${this.URI_SUFFIX.cardSetPin}`;
        break;
      case 'cardLockUnlock':
        URI_SUFFIX = `${this.URI_SUFFIX.cardLockUnlock}`;
        break;
      case 'cardChannelLimit':
        URI_SUFFIX = `${this.URI_SUFFIX.cardChannelLimit}`;
        break;
      case 'cardChannelStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.cardChannelStatus}`;
        break;
      case 'referralStart':
        URI_SUFFIX = `${this.URI_SUFFIX.referralStart}`;
        break;
      case 'dualDocumentAdditionalDocuments':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocument}${id}/additional-documents`;
        break;
      case 'dualDocumentName':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocument}${id}/name`;
        break;
      case 'dualDocumentDob':
        URI_SUFFIX = `${this.URI_SUFFIX.dualDocument}${id}/dob`;
        break;
      case 'perfiosNetbanking':
        URI_SUFFIX = `${this.URI_SUFFIX.perfios}${id}/netbanking`;
        break;
      case 'customerSupport':
        URI_SUFFIX = `${this.URI_SUFFIX.customerSupport}${id}`;
        break;
      case 'customerTransactionPaymentMethod':
        URI_SUFFIX = this.URI_SUFFIX.customerTransactionPaymentMethod;
        break;
      case 'offers':
        URI_SUFFIX = this.URI_SUFFIX.offers;
        break;
      case 'onboardingMarketplace':
        URI_SUFFIX = this.URI_SUFFIX.onboardingMarketplace;
        break;
      case 'supplierTransactionDetails':
        URI_SUFFIX = this.URI_SUFFIX.supplierTransactionDetails;
        break;
      case 'customerBlockedTransactions':
        URI_SUFFIX = `${this.URI_SUFFIX.customerBlockedTransactions}${id}`;
        break;
      case 'customerPaymentLink':
        URI_SUFFIX = this.URI_SUFFIX.customerPaymentLink;
        break;
      case 'customerDeliveryUpdate':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}${id}/delivery-update/${id2}`;
        break;
      case 'creditloanApprovedAmountDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloanApprovedAmount}${id}/details`;
        break;
      case 'applicationMerchantOnboardingLink':
        URI_SUFFIX = this.URI_SUFFIX.applicationMerchantOnboardingLink;
        break;
      case 'customerPhoneBySession':
        URI_SUFFIX = this.URI_SUFFIX.customerPhoneBySession;
        break;
      case 'customerReferralLink':
        URI_SUFFIX = this.URI_SUFFIX.customerReferralLink;
        break;
      case 'rewards':
        URI_SUFFIX = this.URI_SUFFIX.rewards;
        break;
      case 'rewardsById':
        URI_SUFFIX = `${this.URI_SUFFIX.rewards}/${id}`;
        break;
      case 'homeFlags':
        URI_SUFFIX = this.URI_SUFFIX.homeFlags;
        break;
      case 'digiLockerKarzaOtp':
        URI_SUFFIX = this.URI_SUFFIX.digiLockerKarzaOtp;
        break;
      case 'digiLockerKarzaVerifyOtp':
        URI_SUFFIX = this.URI_SUFFIX.digiLockerKarzaVerifyOtp;
        break;
      case 'v2digiLockerKarzaVerifyOtp':
        URI_SUFFIX = this.URI_SUFFIX.v2digiLockerKarzaVerifyOtp;
        break;
      case 'signdesk':
        URI_SUFFIX = this.URI_SUFFIX.signdesk;
        break;
      case 'customerBankName':
        URI_SUFFIX = this.URI_SUFFIX.customerBankName;
        break;
      case 'customerBranchNameIfsc':
        URI_SUFFIX = this.URI_SUFFIX.customerBranchNameIfsc;
        break;
      case 'generateStatement':
        URI_SUFFIX = this.URI_SUFFIX.generateStatement;
        break;
      case 'initiateTransaction':
          URI_SUFFIX = this.URI_SUFFIX.initiateTransaction;
          break;
      case 'otherBanks':
        URI_SUFFIX = this.URI_SUFFIX.otherBanks;
        break;
      case 'processTransaction':
        URI_SUFFIX = this.URI_SUFFIX.processTransaction;
        break;
      case 'initPaytmSubscription':
          URI_SUFFIX = this.URI_SUFFIX.initPaytmSubscription;
          break;
      case 'registerPaytmMandate':
        URI_SUFFIX = this.URI_SUFFIX.registerPaytmMandate;
        break;
      case 'paymentDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.paymentDetails}/${id}/payments-details`;
        break;
      case 'createConsentOneMoney':
          URI_SUFFIX = `${this.URI_SUFFIX.createConsent}`;
          break;
      case 'downloadLoanDocumentByDocumentId':
        URI_SUFFIX = `${this.URI_SUFFIX.application}file/${id}`;
        break;
      case 'gstinVerificationStatus':
          URI_SUFFIX = `${this.URI_SUFFIX.gstinVerificationStatus}`;
          break;
      case 'v6Emandate':
        URI_SUFFIX = `${this.URI_SUFFIX.v6Emandate}${id}/mandate/availability`;
        break;
      case 'consentStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.consentStatus}`;
        break;
      case 'initiateReKyc':
        URI_SUFFIX = `${this.URI_SUFFIX.initiateReKyc}`;
        break;
      case 'pancardDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.customer}application/${id}/pan-details`;
        break;
      case 'generateOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.digitap}/${id}/udyam-details/generate-otp`;
        break;
      case 'submitOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.digitap}/${id}/udyam-details/submit-otp`;
        break;
      case 'submitUdyamDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.digitap}/${id}/udyam-details/submit-udyam`;
        break;
      case 'opsNextAction':
        URI_SUFFIX = `${this.URI_SUFFIX.ops}/${id}/nextAction`;
        break;
      case 'notification':
        URI_SUFFIX = `${this.URI_SUFFIX.application}notification`;
        break;
      case 'applyCoupon':
        URI_SUFFIX = `/v1/repayment/${id}/apply-coupon/${id2}`;
        break;
      case 'processingFeeCouponPayment':
        URI_SUFFIX = `/v1/repayment/${id}/processing-fee-coupon-payment`;
        break;
      case 'creditLoanSignMethod':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/loan-sign-method`;
        break;
      case 'creditLoanSanctionDocument':
        URI_SUFFIX = `${this.URI_SUFFIX.creditloan}${id}/sanction-document`;
        break;
      case 'aadharEsign':
        URI_SUFFIX = `${this.URI_SUFFIX.aadhar}/esign/${id}`;
        break;
      case 'currentAddress':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/current-address`;
        break;
      case 'aadharAddress':
        URI_SUFFIX = `${this.URI_SUFFIX.application}${id}/aadhar-address`;
        break;
      case 'guarantorRelationList':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/relation-list`;
        break;
      case 'guarantorDigiLockerUrl':
        URI_SUFFIX = `${this.URI_SUFFIX.signzy}guarantor/${id}/digilocker-url`;
        break;
      case 'guarantorDigilockerStatus':
        URI_SUFFIX = `${this.URI_SUFFIX.signzy}guarantor/${id}/digilocker-status`;
        break;
      case 'guarantorResendOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/${id}/resend-otp`;
        break;
      case 'guarantorPersonalDetails':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/${id}/personal-details`;
        break;
      case 'guarantorPan':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/${id}/pan`;
        break;
      case 'guarantorLogin':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/login`;
        break;
      case 'guarantorVerifyOtp':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/${id}/verify-otp`;
        break;
      case 'guarantorSummary':
        URI_SUFFIX = `${this.URI_SUFFIX.guarantor}/${id}/summary`;
        break;
      case 'esignGuarantor':
          URI_SUFFIX = `${this.URI_SUFFIX.aadhar}/esign/guarantor/${id}`;
        break;
      case 'aadharEsignSanction':
          URI_SUFFIX = `${this.URI_SUFFIX.aadhar}/esign/${id}/sanction`;
          break;
      default:
        URI_SUFFIX = '';
        break;
    }
    return `${this.API_BASE_URI}${URI_SUFFIX}`;
  },
};
